// extracted by mini-css-extract-plugin
export default {"button":"T2Button_button__5EdJn"};